import { Outlet } from "react-router-dom";

import { useAppSSEEvents } from "@src/features/sse";
import { useActor } from "@src/shared/providers/actorProvider";

import { AuthenticatedLayoutV2 } from "../../../ui/layout/v2";

export function AuthenticatedLayoutV2Route() {
  const actor = useActor();
  const userId = actor.user.id;

  useAppSSEEvents(userId, actor.type, {
    enabled: userId != null,
  });

  return (
    <AuthenticatedLayoutV2>
      <Outlet />
    </AuthenticatedLayoutV2>
  );
}
